import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=63095450&scoped=true&"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeScreen.vue?vue&type=style&index=0&id=63095450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63095450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63095450')) {
      api.createRecord('63095450', component.options)
    } else {
      api.reload('63095450', component.options)
    }
    module.hot.accept("./WelcomeScreen.vue?vue&type=template&id=63095450&scoped=true&", function () {
      api.rerender('63095450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CarrierMarketplace/OnboardingComponents/WelcomeScreen.vue"
export default component.exports